<template>
	<div id="app" class="ss-signup" v-if="ready">
		<router-view></router-view>

		<el-dialog :title="modalTitle"
							 :visible.sync="modal"
							 :width="dialogWidth"
							 @close="handleClose"
							 :append-to-body="false">
			<div v-html="modalBody"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="modal = false">Close</el-button>				
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { rest } from "@/utilities/rest.js";

	let vm;

	window.loadModal = function(instance) {
		vm.modalTitle = $(instance).data("modal");
		vm.modalBody = vm.$store.state.modals[$(instance).data("modal")];
		vm.modal = true;
	}

	export default {
		data() {
			return {
				ready: false,
				dialogWidth: null,
				modal: false,
				modalTitle: null,
				modalBody: null
			}
		},

		created() {

			vm = this;
			this.modalWidth();
			
			rest.get("Signup/", "GetConfiguration", "json").done(response => {
				let payload = JSON.parse(response);
				this.$store.state.plans = payload.shared.plans;
				this.$store.state.locations = payload.shared.locations;
				this.$store.state.steps = payload.signup.steps;
				this.$store.state.terms = payload.signup.terms;
				this.$store.state.modals = payload.signup.modals || {};
			}).always(() => {
				this.ready = true;
			});

		},

		components: {			
			
		},

		
		methods: {

			handleClose() {
				this.modalBody = null;		
			},

			modalWidth() {
				if (window.innerWidth < 600) {
					this.dialogWidth = "90%";
				} else {
					this.dialogWidth = "60%";
				}
			},
		},

		computed: {
			
		}
	}
</script>

<style>

	.ss-signup-banner {
		margin-top: 0px;
		margin-bottom: 0;
		padding: 0 10px;		
	}

	.ss-signup-banner .ss-icon {
		display: none;
	}
	.ss-signup-banner h1 {
		color: #000;
		margin-top: 0;
		margin-bottom: 0px;
		font-size: 14px;
		line-height: 16px;
	}
	.ss-signup-banner h1.fa {
		font-size: 24px;
	}
	.ss-signup-banner h4 {
		color: #666666;
		margin-bottom: 0px;
		margin-top: 0;
		font-size: 14px;
	}
	
	.has-error input,
	.has-error select {
		border-color: red;
	}

	/* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {  
 
  }
 
  /* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
  @media (min-width: 768px) {  
		
  }
 
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
		.ss-signup-banner {
			text-align: center;
			margin-bottom: 0;
			background: #cc6600;
			padding: 50px;
			color: white;
		}

		.ss-signup-banner .ss-icon {
			display: block;
		}
		.ss-signup-banner h1 {
			color: white;
			margin-top: 0;
			margin-bottom: 5px;
			font-size: 22px;
			line-height: 24px;
		}
		.ss-signup-banner h1.fa {
			font-size: 50px;
			margin-bottom: 20px;
			margin-top:10px;
		}
		.ss-signup-banner h4 {
			color: #ebebeb;
			margin-bottom: 0px;
			margin-top: 0;
			font-size: 18px;
		}
  }
 
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {  
    
  }
</style>
